import { Routes } from '@angular/router';

/** Top-level auth and public routes (not under `home`). */
export const authRoutes: Routes = [
  {
    path: 'signin',
    loadComponent: () => import('./sign-in/sign-in.component').then((m) => m.SignInComponent),
  },
  {
    path: 'test/login',
    loadComponent: () => import('./test-sign-in/test-sign-in.component').then((m) => m.TestSignInComponent),
  },
  {
    path: 'under-maintainance',
    loadComponent: () =>
      import('./error-states/under-maintainance/under-maintainance.component').then((m) => m.UnderMaintainanceComponent),
  },
  {
    path: 'no-internet',
    loadComponent: () => import('./error-states/no-internet/no-internet.component').then((m) => m.NoInternetComponent),
  },
  {
    path: 'contact-admin',
    loadComponent: () => import('../forms/contact-admin/contact-admin.component').then((m) => m.ContactAdminComponent),
  },
  {
    path: '404-not-found',
    loadComponent: () => import('./error-states/no-internet/no-internet.component').then((m) => m.NoInternetComponent),
  },
  {
    path: 'verification/:type',
    loadComponent: () => import('./verification/verification.component').then((m) => m.VerificationComponent),
  },
  {
    path: 'email-not-found',
    loadComponent: () =>
      import('./error-states/email-not-registered/email-not-registered.component').then((m) => m.EmailNotRegisteredComponent),
  },
  // Intentional duplication — public URL for signed-out users
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('libs/shared/ui-components/src/lib/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('libs/shared/ui-components/src/lib/terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },
];
